export class StorageService {
    private static getStorage(isPersist: boolean = false): Storage | undefined {
        if (!StorageService.canAccessStorage()) {
            return undefined;
        }
        return isPersist ? localStorage : sessionStorage;
    }

    static setItem<T>(key: string, value: T, isPersist: boolean = false): void {
        const storage = this.getStorage(isPersist);
        storage?.setItem(key, JSON.stringify(value));
    }

    static getItem<T>(key: string): T | undefined {
        if (!StorageService.canAccessStorage()) {
            return undefined;
        }
        const sessionValue = sessionStorage && sessionStorage.getItem(key);
        if (sessionValue) {
            return JSON.parse(sessionValue);
        }

        const localValue = localStorage && localStorage.getItem(key);
        return localValue ? JSON.parse(localValue) : undefined;
    }

    static removeItem(key: string): void {
        if (!StorageService.canAccessStorage()) {
            return;
        }
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
    }

    static canAccessStorage(): boolean {
        return typeof window !== 'undefined';
    }
}
